import { ESearchModalState } from '../../../types/searchModal';

export const isTagsScreen = (state: ESearchModalState) =>
  state === ESearchModalState.Tags || state === ESearchModalState.EmptyTags;
